export const ACTION_LABEL = 'recently viewed';
